<template>
  <div class="container--fluid fill-height d-flex flex-column justify-center align-center text-center">
    <v-icon size="200">mdi-link-off</v-icon>
    <div class="display-1 mt-12 font-weight-bold text--primary">Oops</div>
    <p class="mt-5" style="max-width: 300px">Looks like a broken link, please check the link and try again</p>
  </div>
</template>

<script>
  export default {
    name: "PageNotFound"
  }
</script>
